"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _events = require("../../utils/events.js");
var _helpers = require("./../../utils/helpers");
var _ActionButtonModule = _interopRequireDefault(require("../../scss/buttons/ActionButton.module.scss"));
function ActionButton(_ref) {
  let {
    label,
    type = 'button',
    onClick = () => {},
    varient = '',
    size = '',
    customColors = {
      bgColor: "",
      bgHoverColor: "",
      color: "",
      hoverColor: "",
      borderColor: "",
      borderHoverColor: ""
    },
    disabled,
    classname = "",
    ...attributes
  } = _ref;
  const [btnStatus, setBtnStatus] = (0, _react.useState)('idle'); // idle, waiting

  const varientClass = varient === '' ? "" : "action-btn--".concat(varient);
  const sizeClass = size === '' ? "" : "action-btn--".concat(size);
  const cssVars = customColors.bgColor !== "" ? {
    '--button-bg-color': customColors.bgColor,
    '--button-hover-bg-color': customColors.bgHoverColor === '' ? customColors.bgColor : customColors.bgHoverColor,
    '--button-color': customColors.color,
    '--button-hover-color': customColors.hoverColor === '' ? customColors.color : customColors.hoverColor,
    '--button-border-color': customColors.borderColor === '' ? customColors.bgColor : customColors.borderColor,
    '--button-hover-border-color': customColors.borderHoverColor === '' ? customColors.borderColor === '' ? customColors.bgColor : customColors.borderHoverColor : customColors.borderHoverColor
  } : null;
  const actionCompleted = () => {
    setBtnStatus('idle');
  };
  const handleClick = e => {
    onClick(e);
    setBtnStatus('waiting');
    (0, _events.publish)('scripps:actionbtn:clicked');
  };
  (0, _react.useEffect)(() => {
    (0, _events.subscribe)('scripps:action:completed', actionCompleted);
    return () => {
      (0, _events.unsubscribe)("scripps:action:completed");
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    type: type,
    className: (0, _helpers.classes)([_ActionButtonModule.default['action-btn'], 'action-btn', classname, varient === '' ? '' : _ActionButtonModule.default[varientClass], size === '' ? '' : _ActionButtonModule.default[sizeClass]]),
    onClick: handleClick,
    disabled: btnStatus === 'waiting' || disabled,
    style: cssVars
  }, attributes), btnStatus !== 'waiting' && /*#__PURE__*/_react.default.createElement("span", {
    className: _ActionButtonModule.default['action-btn__label']
  }, label), btnStatus === 'waiting' && /*#__PURE__*/_react.default.createElement("div", {
    className: _ActionButtonModule.default['dots-pulse']
  }, /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null)));
}
var _default = exports.default = ActionButton;